/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useMemo, useState } from "react";
import { CSVLink } from "react-csv";
import PageTitle from "../../../../components/pageTitle/PageTitle";
import moment from "moment-timezone";
import { Container } from "@material-ui/core";
import SingleSelectNew from "../../../../components/SelectField/SingleSelectNew";
import { getCompanyClients } from "../../../../services/apiservices/client";
import CircularProgress from "@mui/material/CircularProgress";
import * as Excel from 'exceljs';
import { downloadPDF, downloadExcel } from "../../DownloadReportUtils";
import { useMediaQuery } from "@mui/material";
import dayjs from "dayjs";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import AuthContext from "../../../../hooks/authContext";
import ActionRender from "../../ActionRender";
import { Label } from "../../../../components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "../../../../components/ui/card";
import { Calendar, CheckSquare, Download, FileSpreadsheet, FileText, Filter, Info, Mail, TrendingUp } from "lucide-react";
import { Button } from "../../../../components/ui/button";
import { getUpcomingClientTimesheetListReport } from "../../../../services/apiservices/timesheets";
import { getEmployeesListBasedOnId } from "../../../../services/apiservices/employee";
import { Popover, PopoverContent, PopoverTrigger } from "../../../../components/ui/popover";
import ThemeTable from "../../../../components/Table/ThemeTable";
import { MobileTaskCompletionSummaryReport, MobileTaskSummaryReport } from "../ClientMobileViewReports";
import EmailReports from "../../EmailReports";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../../../../components/ui/tooltip";
import { Progress } from "../../../../components/ui/progrss";
import { getSettings } from "../../../../services/apiservices/settings";

const TaskCompletionSummary = () => {
const csvHeaders = [
    "Client",
    "Start date",
    "End date",
    "Assigned",
    "Completed",
    "Completion Rate",
    "Avg Time",
    "Pending",
    "Overdue",
  ];
  const [clientsList, setClientList] = useState([]);
  const [clientsListMaster, setClientsListMaster] = useState([]);
  const [clientsListCSV, setClientListCSV] = useState([csvHeaders]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [openEmailDialog, setOpenEmailDialog] = useState(false);
  const [clients, setClients] = useState();
  const [settingsData, setSettingsData] = useState();
  const [clientName, setClientName] = useState("All");
  const [clientNameList, setClientNameList] = useState([
    { label: "All", value: "All" },
  ]);
  const isMobile = useMediaQuery('(max-width:767px)');
  const isLandscape = useMediaQuery('(min-width: 771px) and (max-width: 940px)');
  const auth = useContext(AuthContext);
  const [loader, setLoader] = useState(false);
  const companyId = auth?.userProfile?.role === "companyUser" ? auth?.userProfile?.id : auth?.userProfile?.companyId;

  const getColumns = () => {
    const columns = [
      {
        id: "clientName",
        numeric: false,
        disablePadding: false,
        label: "Client",
        isSortable: false,
      },
      {
        id: "startdate",
        numeric: false,
        disablePadding: false,
        label: "Start date",
        isSortable: false,
      },
      {
        id: "enddate",
        numeric: false,
        disablePadding: false,
        label: "End date",
        isSortable: false,
      },
      {
        id: "assigned",
        numeric: false,
        disablePadding: false,
        label: "Assigned",
        isSortable: false,
      },
      {
        id: "completed",
        numeric: false,
        disablePadding: false,
        label: "Completed",
        isSortable: false,
      },
      {
        id: "completionrate",
        numeric: false,
        disablePadding: false,
        label: "Completion Rate",
        isSortable: false,
      },
      {
        id: "avgtime",
        numeric: false,
        disablePadding: false,
        label: "Avg Time",
        isSortable: false,
      },
      {
        id: "pending",
        numeric: false,
        disablePadding: false,
        label: "Pending",
        isSortable: false,
      },
      {
        id: "overdue",
        numeric: false,
        disablePadding: false,
        label: "Overdue",
        isSortable: false,
      },
      {
        id: "Action",
        numeric: false,
        disablePadding: false,
        label: "Action",
        isSortable: false,
      },
    ];
    if (isMobile || isLandscape) {
      return columns.filter(col => col.id !== "clientName" && col.id !== "appointmentDate" && col.id !== "Action");
    }
    return columns;
  };

  useEffect(() => {
    const getClientsData = async () => {
      const [clientRes, settingsRes] = await Promise.all([
        new Promise((resolve) => getCompanyClients(companyId, resolve)),
        new Promise((resolve) =>
          getSettings("client_settings", (res) => resolve(res?.data))
        ),
      ]);
      const details = Array.isArray(clientRes?.data) ? clientRes?.data : [];
      const client = details?.map((item) => {
        return {
          value: item?.id,
          label: `${item?.firstName} ${item?.lastName}`,
        };
      });
      const filteredData = settingsRes?.filter(
        (item) => item?.companyId === companyId && !item.deleted
      );
      setSettingsData(filteredData?.length ? filteredData : []);
      setClients(details);
      setClientNameList([{ label: "All", value: "All" }, ...client]);
    };
    getClientsData();
  }, []);

  const handleclientNameChange = (e) => {
    const str = e;
    setClientName(str);
    if (str === "All") {
      setClientList(clientsListMaster);
    } else {
      setClientList(() =>
        clientsListMaster?.filter((itme) => {
          let returnFlg = true;
          if (str !== "All" && returnFlg) {
            returnFlg = itme?.clientNameId === str;
          }
          return returnFlg;
        })
      );
    }
  };

  const getDatatoDownload = (rcellItem) => {
    let clientCSV = [];
    if (!Array.isArray(rcellItem)) {
      clientCSV = clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      clientCSV = clientCSV?.map((item) => {
        return [
          item?.clientName,
          item?.startdate,
          item?.enddate,
          item?.assigned,
          item?.completed,
          item?.completionrate,
          item?.avgtime,
          item?.pending,
          item?.overdue,
        ];
      });
    } else {
      clientCSV = rcellItem?.map((item) => {
        return [
          item?.clientName,
          item?.startdate,
          item?.enddate,
          item?.assigned,
          item?.completed,
          item?.completionrate,
          item?.avgtime,
          item?.pending,
          item?.overdue,
        ];
      });
    }
    return clientCSV;
  }

  const getDatatoFullDownload = (rcellItem) => {
    if (rcellItem) {
       clientsList?.filter(
        (item) => item.clientNameId === rcellItem.clientNameId
      );
      return [
        rcellItem?.clientName,
        rcellItem?.startdate,
        rcellItem?.enddate,
        rcellItem?.assigned,
        rcellItem?.completed,
        rcellItem?.completionrate,
        rcellItem?.avgtime,
        rcellItem?.pending,
        rcellItem?.overdue,
      ];
    } else {
      return [
      rcellItem?.clientName,
        rcellItem?.startdate,
        rcellItem?.enddate,
        rcellItem?.assigned,
        rcellItem?.completed,
        rcellItem?.completionrate,
        rcellItem?.avgtime,
        rcellItem?.pending,
        rcellItem?.overdue,
      ];
    }
  }

  const downloadForExcel = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Task Completion Summary Report');

    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `TaskCompletionSummaryReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `TaskCompletionSummaryReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const downloadForPDF = async (rcellItem, emailSend) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);
    let fileName;
    if (Array.isArray(rcellItems)) {
      fileName = `TaskCompletionSummaryReport_${rcellItems[0]?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    } else {
      fileName = `TaskCompletionSummaryReport_${rcellItems?.clientName}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`;
    }
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const setDownloadCSVData = (event, done, rcellItem) => {
    const rcellItems = rcellItem?.records ? rcellItem?.records : rcellItem;
    const clientCSV = getDatatoDownload(rcellItems);

    const reportName = "Task Completion Summary Report";
    const clientName = Array.isArray(rcellItems) ? `${rcellItems[0]?.clientName}` : `${rcellItems?.clientName}`;
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(endDate).format("YYYY-MM-DD")}`;
    // Create the report details rows
    const reportDetails = [
      [`Client Name: ${clientName}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV
    ];

    // Set the CSV data
    setClientListCSV(reportDetails);
    done();
  };

  const setDownloadFullCSVData = (event, done) => {
    const clientCSV = clientsList?.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = "All";

    if (clientName !== "All") {
      clientNamefordwonLoad = clientNameList?.filter(
        (item) => item.value === clientName
      )[0]?.label;
    }

    const reportName = "Task Completion Summary Report";
    const reportPeriod = `${moment(startDate).format("YYYY-MM-DD")} to ${moment(
      endDate
    ).format("YYYY-MM-DD")}`;

    const reportDetails = [
      [`Employee Name: ${clientNamefordwonLoad}`],
      [`Report Name: ${reportName}`],
      [`Report Period: ${reportPeriod}`],
      [],
      [...csvHeaders],
      ...clientCSV,
    ];

    setClientListCSV(reportDetails);
    done();
  };


  const downloadForFullPDF = async (emailSend) => {
    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));
    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `TaskCompletionSummaryReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    const logo = settingsData?.[0]?.companyLogo;
    return await downloadPDF(logo, clientCSV, csvHeaders, fileName, emailSend);
  }

  const downloadForFullExcel = async (emailSend) => {
    let wb = new Excel.Workbook();
    let ws = wb.addWorksheet('Task Completion Summary Report');
    let clientNamefordwonLoad = 'All'

    const clientCSV = clientsList.map((item) => getDatatoFullDownload(item));

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList.filter((item) => item.value === clientName)[0].label
    }
    let fileName = `TaskCompletionSummaryReport_${clientNamefordwonLoad}_${moment(startDate).format("YYYY-MM-DD")}_${moment(endDate).format("YYYY-MM-DD")}`
    return await downloadExcel(clientCSV, csvHeaders, wb, ws, fileName, emailSend)
  }

  const handleEmailIconClick = async (rcellItem) => {
    const emailSend = true;
    const excelBlob = await downloadForExcel(rcellItem, emailSend);
    let name;
    if (Array.isArray(rcellItem)) {
      name = rcellItem[0]?.clientName;
    } else {
      name = rcellItem?.clientName;
    }
    localStorage.setItem("FileName", "TaskCompletionSummaryReport");

    localStorage.setItem("ReportsName", "Client Report");

    localStorage.setItem("Name", name);

    localStorage.setItem("Date", startDate);

    localStorage.setItem("EndDate", endDate);

    const pdfBlob = await downloadForPDF(rcellItem, emailSend);
    localStorage.setItem("pdfData", pdfBlob);
    localStorage.removeItem("fullReport")
    localStorage.removeItem("fullExcelReport")

    // Convert the Excel blob to a base64-encoded string
    const reader = new FileReader();
    reader.readAsDataURL(excelBlob);
    reader.onloadend = function () {
      const base64Data = reader.result;
      localStorage.setItem("emailData", base64Data);
      setOpenEmailDialog(true);
    };
  };

  const handelEmailFullReport = async () => {
    const emailSend = true;

    localStorage.setItem("FileName", "TaskCompletionSummaryReport");

    localStorage.setItem("ReportsName", "Client Report");

    let clientNamefordwonLoad = 'All'

    if (clientName !== 'All') {
      clientNamefordwonLoad = clientNameList?.filter((item) => item.value === clientName)[0]?.label
    }
    localStorage.setItem("Name", clientNamefordwonLoad);

    localStorage.setItem("Date", startDate);

    localStorage.setItem("EndDate", endDate);

    const fullReport = await downloadForFullPDF(emailSend);
    localStorage.setItem("fullReport", fullReport);
    localStorage.removeItem("pdfData")
    localStorage.removeItem("emailData")

    const fullExcelReport = await downloadForFullExcel(emailSend);
    const reader = new FileReader();
    reader.readAsDataURL(fullExcelReport);
    reader.onloadend = function () {
      const base64Data = reader.result;
      localStorage.setItem("fullExcelReport", base64Data);
      setOpenEmailDialog(true);
    }
  }


  const handleGenerateReport = async() => {
      setLoader(true);
      let paramStartDate = "";
      let paramEndDate = "";

      paramStartDate = startDate;
      paramEndDate = endDate;
      getReportListData(paramStartDate, paramEndDate);
  }

  function toDate(ts) {
    if (!ts) return null;
    if (ts instanceof Date) return ts; 
    if (typeof ts.toDate === "function") return ts.toDate();
    if (ts?.seconds) return new Date(ts.seconds * 1000 + Math.floor(ts.nanoseconds / 1000000));
    return null;
  }

  const mapWithClientIds = async (employeeIds, timeSheet) => {
    getEmployeesListBasedOnId(employeeIds, (employeesList) => {
      const groupedByClient = {};
      timeSheet?.forEach((record) => {
        if (!groupedByClient[record?.clientId]) {
          groupedByClient[record?.clientId] = [];
        }
        groupedByClient[record?.clientId]?.push(record);
      });

      const finalData = [];

      Object.entries(groupedByClient)?.forEach(([clientId, records]) => {
        const clientInfo = clients?.find((c) => c?.id === clientId);
        const clientName = clientInfo?.clientName || "UnKnown";
        const clientNameId = clientInfo?.id || "UnKnown";

        const totalAppointments = records?.length;
        let cancelledCount = 0;
        let rescheduledCount = 0;
        let totalTasks = 0;
        let completedTasks = 0;
        let inCompletedTasks = 0;
        let overdueTasks = 0;
        const uniqueUserIds = new Set();

        let totalDurationMinutes = 0;
        let countedAppointments = 0;

        records?.forEach((rec) => {
          const details = rec?.apoointmentDetails || {};

          if (details?.status === "Cancelled") {
            cancelledCount++;
          }

          if (details?.historyDate) {
            rescheduledCount++;
          }

          if (rec?.checkInDateTime && rec?.checkOutDateTime) {
            const checkIn = toDate(rec?.checkInDateTime);
            const checkOut = toDate(rec?.checkOutDateTime);

            if (checkIn && checkOut && !isNaN(checkIn) && !isNaN(checkOut)) {
              const diffMinutes = Math.max(0, (checkOut - checkIn) / (1000 * 60));
              totalDurationMinutes += diffMinutes;
              countedAppointments++;
            }
          }

          if (rec?.tasks) {
            Object.values(rec?.tasks)?.forEach(taskGroup => {
              if (Array.isArray(taskGroup?.tasksList)) {
                totalTasks += taskGroup?.tasksList?.length;
                const comp = taskGroup?.tasksList?.filter(t => t?.completed === true)?.length;
                const inComp = taskGroup?.tasksList?.filter(t => t?.completed !== true)?.length;

                completedTasks += comp;

                if (inComp > 0) {
                  if (rec?.checkInDateTime && rec?.checkOutDateTime) {
                    overdueTasks += inComp;
                  } else {
                    inCompletedTasks += inComp;
                  }
                }
              }
            });
          }

          if (rec?.userId) {
            uniqueUserIds.add(rec?.userId);
          }
        });

        let avgDuration = "0 hours";
        if (countedAppointments > 0 && !isNaN(totalDurationMinutes)) {
          const hours = totalDurationMinutes / 60 / countedAppointments;
          avgDuration = isFinite(hours) ? hours.toFixed(1) + " hours" : "0 hours";
        }

        const taskCompletionPercentage = totalTasks > 0
          ? ((completedTasks / totalTasks) * 100).toFixed(0)
          : "0";

        const taskSummary = `${taskCompletionPercentage}% ${completedTasks}/${totalTasks}`;

        const employeeNames = Array.from(uniqueUserIds)?.map(uid => {
          const emp = employeesList?.find(e => e.id === uid);
          return emp ? `${emp.firstName} ${emp.lastName}` : "";
        }).filter(Boolean);

        finalData.push({
          clientId,
          clientNameId,
          clientName,
          totalAppointments,
          count: totalAppointments,
          canceled: cancelledCount,
          reschedule: rescheduledCount,
          task: taskSummary,
          assigned: totalTasks,
          completed: completedTasks,
          pending: inCompletedTasks,
          completionrate: taskCompletionPercentage,
          employee: employeeNames?.length,
          startdate: moment(startDate).format("MMM YYYY"),
          enddate: moment(endDate).format("MMM YYYY"),
          avgtime: avgDuration,
          overdue: overdueTasks,
          cancelledCount,
          rescheduledCount,
          totalTasks,
          completedTasks,
          inCompletedTasks,
          taskCompletionPercentage,
          taskSummary,
          uniqueUserIds,
          uniqueEmployeeCount: uniqueUserIds.size,
          employeeNames
        });
      });
      const sortedData = sortingFunction(finalData);
      setClientsListMaster(sortedData);
      setClientList(sortedData);
      setLoader(false);
    });
  };

  const sortingFunction = (data) => {
    const result = data.sort((a, b) => {
      if (a.clientName < b.clientName) return -1;
      if (a.clientName > b.clientName) return 1;
      // If clientName is the same, sort by appointmentDate
      if (a.appointmentDateTime < b.appointmentDateTime) return -1;
      if (a.appointmentDateTime > b.appointmentDateTime) return 1;
      return 0;
    });

    return result;
  };

  const getReportListData = async (startDt, endDt) => {
    const param = {
      startDate: `${dayjs(startDt).format("YYYY-MM-DD")}T00:00:00`,
      endDate: `${dayjs(endDt).format("YYYY-MM-DD")}T23:59:59`
    };

    getUpcomingClientTimesheetListReport(
      param,
      clientName,
      companyId,
      (result) => {
        const data = result;
        const employeeIds = [];
        for (let i = 0; i < data?.length; i++) {
          if (employeeIds?.indexOf(data?.[i].userId) === -1) {
            employeeIds?.push(data?.[i].userId);
          }
        }

        mapWithClientIds(employeeIds, data);
      },
      (err) => {
        console.log("err>>", err);
      }
    );
  };

  const getCompletionRateColor = (rate) => {
    if (rate >= 90) return 'text-green-600 dark:text-green-400';
    if (rate >= 80) return 'text-yellow-600 dark:text-yellow-400';
    return 'text-red-600 dark:text-red-400';
  };

  const renderRowCell = (rcellItem, hcellItem, index, rowindex,) => {
    switch (hcellItem.id) {
      case "clientName":
        if (
          rowindex !== 0 &&
          clientsList[rowindex - 1].clientName !== rcellItem.clientName
        ) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else if (rowindex === 0) {
          return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
        } else {
          return "";
        }
      case "count":
        return (
          <div className="text-sm font-semibold text-primary">
            {rcellItem?.count}
          </div>
        );
      case "completionrate":
        return (
          <div className="flex items-center space-x-2">
          <Progress value={rcellItem?.completionrate} className="w-12 h-2" />
            <span className={`text-sm font-medium ${getCompletionRateColor(rcellItem?.completionrate)}`}>
                {rcellItem?.completionrate}%
            </span>
          </div>
        );
      case "canceled":
        return (
          <div className="text-sm text-destructive">{rcellItem?.canceled}</div>
        );
      case "reschedule":
        return (
          <div className="text-sm text-orange-600 dark:text-orange-400">
            {rcellItem?.reschedule}
          </div>
        );
      case "task":
        return (
          <div className="d-flex flex-direction-column">
            <div className="text-sm">
             {rcellItem?.totalTasks > 0 ? `${Math.round((rcellItem?.completedTasks / rcellItem?.totalTasks) * 100)}%` : "0%"}
            </div>
            <div className="text-xs text-muted-foreground">
              {rcellItem?.completedTasks}/{rcellItem?.totalTasks}
            </div>
          </div>
        );
      case "employee":
        return (
          <Tooltip>
            <TooltipTrigger asChild>
              <div className="text-sm font-medium cursor-pointer hover:text-primary transition-colors">
                {rcellItem?.employeeNames?.length}
              </div>
            </TooltipTrigger>
            <TooltipContent className="bg-white dark:bg-gray-800 border shadow-lg p-12 max-w-xs">
              <div className="space-y-1">
                {rcellItem?.employeeNames?.map((member, index) => (
                  <div key={index} className="text-sm">
                    {member}
                  </div>
                ))}
              </div>
            </TooltipContent>
          </Tooltip>
        );
      case "Action":
        if (isMobile || isLandscape) {
          if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"TaskCompletionSummaryReport"}
              />
            );
          } else {
            return null;
          }
        } else {
          if (
            rowindex !== 0 &&
            clientsList[rowindex - 1].clientName !== rcellItem.clientName
          ) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"TaskCompletionSummaryReport"}
              />
            );
          } else if (rowindex === 0) {
            return (
              <ActionRender
                rcellItem={rcellItem}
                clientsListCSV={clientsListCSV}
                setDownloadCSVData={setDownloadCSVData}
                downloadPDF={downloadForPDF}
                downloadExcel={downloadForExcel}
                startDate={startDate}
                endDate={endDate}
                handleEmailIconClick={handleEmailIconClick}
                name={"TaskCompletionSummaryReport"}
              />
            );
          } else {
            return "";
          }
        }
      default:
        return <div className="b-none">{rcellItem[hcellItem?.id]} </div>;
    }
  };

  const MobileViewData = useMemo(() => {
    if (!clientsList?.length) return [];

    return clientsList?.reduce((acc, item) => {
      const clientName = item?.clientName;

      const record = {
        id: item?.clientNameId,
        date: item?.appointmentDate,
        clientNameId: item?.clientNameId,
        clientName: item?.clientName,
        totalTasks: item?.totalTasks,
        completedTasks: item?.completedTasks,
        taskCompletionPercentage: item?.taskCompletionPercentage,
        completionrate: item?.completionrate,
        employee: item?.employeeNames,
        reschedule: item?.reschedule,
        startDate: item?.startdate,
        endDate: item?.enddate,
        task: item?.task,
        assigned: item?.assigned,
        completed: item?.completed,
        pending: item?.pending,
        employee: item?.employee,
        employeeNames: item?.employeeNames,
        count: item?.count,
        canceled: item?.canceled,
        avgtime: item?.avgtime,
        overdue: item?.overdue,
      };

      const existingGroup = acc?.find((g) => g?.clientName === clientName);

      if (existingGroup) {
        existingGroup?.records?.push(record);
      } else {
        acc?.push({
          clientName,
          records: [record],
        });
      }

      return acc;
    }, []);
  }, [clientsList]);

    const filteredClient = clients?.find((item) => item?.id === clientName);

    const handleEmailDialogClose = async() => {
      setOpenEmailDialog(false);
      await handleGenerateReport();
    }


  return (
    <>
      <Container>
          <PageTitle
            pageTitle="Task Completion Summary Reports"
            showBreadcrumb={[
              { label: "Home", to: "/" },
              { label: "Reports" },
              { label: "New Reports" },
              { label: "Client Reports", to: "/reports/newreport/clientreport" },
            ]}
            BreadCrumbCurrentPageTitle={"Task Completion Summary Reports"}
            showLastSeen={true}
          ></PageTitle>

          <div className={`sectionBox2 dark:bg-[#1A1F2C]`}>
            <div className="mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6 max-w-7xl dark:bg-[#1A1F2C]">
              <div className="space-y-6">
                <Card className="shadow-sm dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] p-24">
                  <CardHeader className="pb-12">
                    <div className="flex items-center space-x-2">
                      <Filter className="w-4 h-4 sm:w-5 sm:h-5 text-primary" />
                      <CardTitle className="text-lg sm:text-xl">
                        Report Parameters
                      </CardTitle>
                    </div>
                    <CardDescription className="text-left text-sm sm:text-base">
                      Configure the parameters for your Task Completion Summary report
                    </CardDescription>
                  </CardHeader>
                  <CardContent>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="client"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Client Name *
                        </Label>
                        <SingleSelectNew
                          value={clientName}
                          name={"clientName"}
                          label={"Client Name"}
                          onChange={(e) => handleclientNameChange(e)}
                          options={clientNameList}
                          contentClass="bg-white text-black border-gray-300 dark:bg-[#2c3440] dark:text-white dark:border-[#464c59]"
                          itemClass="hover:bg-gray-100 dark:hover:bg-[#3c4351]"
                          className="w-full min-h-[40px] px-3 py-2"
                        />
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="startDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          Start Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={startDate}
                            onChange={(newValue) => {
                              setStartDate(newValue);
                              if (newValue) {
                                setEndDate(moment());
                              } else {
                                setEndDate(null);
                              }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>

                      <div className="flex flex-col space-y-1">
                        <Label
                          htmlFor="endDate"
                          className="text-sm font-medium text-gray-700 dark:text-white"
                        >
                          End Date *
                        </Label>
                        <LocalizationProvider dateAdapter={AdapterMoment}>
                          <DatePicker
                            value={endDate}
                            onChange={(newValue) => {
                              setEndDate(newValue);
                              if (!newValue) {
                                setStartDate(null);
                              }
                            }}
                            maxDate={moment()}
                            views={["year", "month", "day"]}
                            inputFormat="YYYY-MM-DD"
                            slotProps={{
                              textField: {
                                variant: "outlined",
                                size: "small",
                                fullWidth: true,
                                className: "customDateInput",
                              },
                            }}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                    <div className="flex justify-start sm:justify-end pt-8">
                      <Button
                        type="submit"
                        className="w-full sm:w-auto h-10 text-sm px-6"
                        onClick={() => handleGenerateReport()}
                      >
                        {loader ? (
                          <CircularProgress
                            size={28}
                            style={{ color: "white" }}
                          />
                        ) : (
                          <span className="d-flex flex-center">
                            <FileText className="w-4 h-4 mr-8" /> Generate
                            Report
                          </span>
                        )}
                      </Button>
                    </div>
                  </CardContent>
                </Card>
    
                {loader ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      Fetching report data...
                    </div>
                  </Card>
                ) : clientsList?.length === 0 ? (
                  <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)] flex items-center justify-center min-h-[200px]">
                    <div className="text-sm sm:text-base text-gray-600 dark:text-gray-300">
                      No Records Found
                    </div>
                  </Card>
                ) : (
                  clientsList?.length > 0 && (
                    <Card className="shadow-sm p-24 dark:bg-[#1A1F2C] shadow-md dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
                      <CardHeader className="pb-16">
                        <div className="flex flex-col space-y-4 lg:flex-row lg:items-start lg:justify-between lg:space-y-0">
                          <div className="space-y-3 flex-1 min-w-0">
                            <CardTitle className="text-lg sm:text-xl d-flex flex-center">
                              <span>
                                  <CheckSquare className="h-5 w-5 mr-5 text-blue-500 dark:text-blue-500"/>
                              </span>
                             Task Completion Summary Report Results
                            </CardTitle>
                            <CardDescription className="space-y-2">
                              <div className="font-medium text-sm sm:text-base">
                                {clientName === "All"
                                  ? "All Client Report"
                                  : `Client Report for ${filteredClient?.firstName} ${filteredClient?.lastName}`}
                              </div>
                              <div className="text-xs sm:text-sm text-gray-600 dark:text-gray-400">
                              </div>
                            </CardDescription>
                          </div>
                          <div className="flex flex-wrap gap-2">
                            <Button
                              variant="outline"
                              size="sm"
                              onClick={() => handelEmailFullReport()}
                              className="h-8"
                            >
                              <Mail className="mr-4 h-3 w-3" />
                              Email Report
                            </Button>
                            <Popover>
                              <PopoverTrigger asChild>
                                <Button
                                  variant="outline"
                                  size="sm"
                                  className="h-8"
                                >
                                  <Download className="mr-4 h-3 w-3" />
                                  Download
                                </Button>
                              </PopoverTrigger>
                              <PopoverContent className="w-40">
                                <div className="space-y-2">
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullPDF()}
                                  >
                                    <FileText className="mr-8 h-3 w-3" />
                                    PDF
                                  </Button>
                                  <Button
                                    variant="ghost"
                                    className="w-full justify-start h-8"
                                    onClick={() => downloadForFullExcel()}
                                  >
                                    <FileSpreadsheet className="mr-8 h-3 w-3" />
                                    Excel
                                  </Button>
                                  <CSVLink
                                    data={clientsListCSV}
                                    filename={`TaskCompletionSummaryReport_${
                                      clientName === "All"
                                        ? "All"
                                        : `${filteredClient?.firstName} ${filteredClient?.lastName}`
                                    }_${moment(startDate).format(
                                      "YYYY-MM-DD"
                                    )}_${moment(endDate).format(
                                      "YYYY-MM-DD"
                                    )}.csv`}
                                    asyncOnClick={true}
                                    onClick={(event, done) => {
                                      setDownloadFullCSVData(event, done);
                                    }}
                                    className="w-full flex justify-start items-center h-8 pv-8 ph-16 text-sm hover:bg-accent hover:text-accent-foreground rounded-md transition-colors"
                                  >
                                    <FileSpreadsheet className="mr-16 h-4 w-4" />
                                    <span className="font-medium">CSV</span>
                                  </CSVLink>
                                </div>
                              </PopoverContent>
                            </Popover>
                          </div>
                        </div>
                      </CardHeader>
                      <CardContent className="p-0 sm:p-6 sm:pt-0">
                        {!isMobile && (
                          <TooltipProvider>
                          <ThemeTable
                            rows={clientsList}
                            headCells={getColumns()}
                            hidePagination={true}
                            renderRowCell={renderRowCell}
                          />
                          </TooltipProvider>
                        )}
                        {isMobile && (
                          <MobileTaskSummaryReport
                            MobileViewData={MobileViewData}
                            handleEmailIconClick={handleEmailIconClick}
                            downloadForPDF={downloadForPDF}
                            downloadForExcel={downloadForExcel}
                            clientsListCSV={clientsListCSV}
                            setDownloadCSVData={setDownloadCSVData}
                            startDate={startDate}
                            endDate={endDate}
                            reportName={"TaskCompletionSummaryReport"}
                          />
                        )}
                      </CardContent>
                    </Card>
                  )
                )}
              </div>
            </div>
          </div>
          <EmailReports
            open={openEmailDialog}
            onClose={() => handleEmailDialogClose()}
          />
        </Container>
    </>
  );
}

export default TaskCompletionSummary;
